import RequestService from "./RequestService";

export type DefinitionRuleType = 0 | 1 | 2;

export interface DefinitionRule {
  typeRule: DefinitionRuleType;
  definitionValues?: number[];
  confidence?: number | null;
}

export interface IARule {
  iaRuleID: number;
  definitionRule: DefinitionRule[];
}

export interface SaveIARulePayload {
  iaRuleID: number | null;
  definitionRule: DefinitionRule[];
}

const normalizeRule = (raw: any): IARule => ({
  iaRuleID: raw.IARuleID ?? raw.iaRuleID,
  definitionRule: (raw.DefinitionRule ?? raw.definitionRule ?? []).map(
    (c: any) => ({
      typeRule: c.TypeRule ?? c.typeRule,
      definitionValues: c.DefinitionValues ?? c.definitionValues ?? [],
      confidence: c.Confidence ?? c.confidence ?? null
    })
  )
});

class IARuleService {
  static async list(): Promise<IARule[] | Error> {
    const res = await RequestService.get<any>("/iarule/list", {});
    if (res instanceof Error) return res;
    const list: any[] = (res as any).list ?? (res as any).List ?? [];
    return list.map(normalizeRule);
  }

  static async save(
    payload: SaveIARulePayload
  ): Promise<{ iaRuleId: number } | Error> {
    const backendPayload = {
      iaRuleID: payload.iaRuleID,
      definitionRule: payload.definitionRule.map((c) => ({
        typeRule: c.typeRule,
        ...(c.typeRule !== 2 ? { definitionValues: c.definitionValues } : {}),
        ...(c.typeRule === 2 ? { Confidence: c.confidence } : {})
      }))
    };
    const res = await RequestService.post<any>("/iarule/save", backendPayload);
    if (res instanceof Error) return res;
    const id = (res as any)?.IARuleId ?? (res as any)?.iaRuleId;
    return { iaRuleId: id };
  }

  static async delete(id: number): Promise<{ deleted: boolean } | Error> {
    return RequestService.delete<{ deleted: boolean }>(`/iarule/${id}`, {});
  }
}

export default IARuleService;
